import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export const ScrollToTop = (): JSX.Element | null => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const { pathname } = location;

  useLayoutEffect(() => {
    if (navigationType === 'PUSH') {
      /**
       * @NOTE(shawk): this assumes that the body is the top-most scrolling
       * context (due to `html {overflow: hidden}`). See `src/styles/base/root.css`
       */
      document.body.scrollTo({ top: 0 });
    }
  }, [pathname]);

  return null;
};
